import React, { Fragment, useState, useEffect, useRef } from 'react';


import { format } from 'date-fns';
import { Button, Dropdown } from 'react-bootstrap';
import axios from 'axios';
import { useTranslation } from 'react-i18next';
import Cookies from 'js-cookie';
import "./ordersTable.css";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
const { config } = require('../api/api');


const MyOmanVisaTable = ({ VendorKey, Payload }) => {
  const base_url = config.baseURL;
  const redirectURL = config.redirectURL;
  const { t } = useTranslation();


  const [show, setShow] = useState(false);
  const [loading, setLoading] = useState(true);
  // const handleClose = () => setShow(false);

  const [odata, setOdata] = useState([]);
  const [orddata, setOrddata] = useState([]);
  const [selectedOption, setSelectedOption] = useState('Visa Orders');
  const [filter,setFilter]=useState('success');


  const handleClose = () => {
    setShow(false);
  };
  
  const lnstr = Cookies.get("langData") ? Cookies.get("langData") : "en";



  const [profile, setProfile] = useState(null);
  const [error, setError] = useState(null);


  const [totalEarnings, setTotalEarnings] = useState('');
  const [insuranceData, setInsuranceData] = useState([]);
  const [currentItems, currentItemsdata]= useState([]);
  const [totalPages, totalPagess]=useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10; // Number of items per page
  const [indexOfFirstItem, setindexOfFirstItem]= useState(0);
  const [indexOfLastItem, setIndexOfLastItem]= useState(0);

  const [iframeUrl, setIframeUrl] = useState("");
  const [showIframe, setShowIframe] = useState(false);
  const [iframeUrl1, setIframeUrl1] = useState("");
  const tableRef=useRef(null);
  const [pageChanged,setPageChanged]=useState(false);

  const [userData,setUserData] = useState(null);
  const [usrtok,setUsrtok]= useState("");
  

  const openIframe = (url) => {
    setIframeUrl(url);
    setShowIframe(true);
  };

  const closeIframe = () => {
    setIframeUrl("");
    setShowIframe(false);
  };

   useEffect(()=>{
      const storedUserString = Cookies.get('userData');
       if (storedUserString !== undefined) {
         const user_data = JSON.parse(storedUserString);
        setUserData(user_data);
         setUsrtok(user_data.access_token);
       }
       },[]);


  useEffect(() => {
    if (show) {
      document.body.style.overflow = 'hidden'; 
    } else {
      document.body.style.overflow = 'auto';
    }
    
    return () => {
      document.body.style.overflow = 'auto'; 
    };
  }, [show]);

  useEffect(() => {
    if (showIframe) {
      document.body.style.overflow = 'hidden'; 
    } else {
      document.body.style.overflow = 'auto';
    }
    
    return () => {
      document.body.style.overflow = 'auto'; 
    };
  }, [showIframe]);

      // ✅ Load SmartBox script
      useEffect(() => {
        const script = document.createElement("script");
        script.src = config.amwalpayURL;
        script.async = true;
        document.body.appendChild(script);
    
        return () => {
          document.body.removeChild(script);
        };
      }, []);


  const handleStatus =(e,app_id)=>{
    e.preventDefault();
      if (VendorKey) {
    
              const app_data={application_id:app_id}
                fetch(base_url + '/get_oman_visa_order_details', {
                    method: 'POST',
                    headers: {
                        "Authorization":"Bearer "+VendorKey,
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify(app_data),
                })
                .then(response => response.json())
                .then(data => {
                  if(data.message==="success"){
                    // setApplicationData(data.result);
                     setOdata(data.result);
                    //  setOrddata(response.data.result.order.order_id);
                     setShow(true);
                  }
                })
                .catch(error => {
                  toast.error(error.message)
                    console.error('Error fetching oman visa app :', error);
                });
            }
  }


 const calculatePagination = (page,list) => {
    debugger
    const indexOfLastItem = page * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    setIndexOfLastItem(indexOfLastItem);
    setindexOfFirstItem(indexOfFirstItem);
    const currentItem = list.slice(indexOfFirstItem, indexOfLastItem);
    currentItemsdata(currentItem);
  };
  
  const handleNextPage = () => {
    debugger
    setCurrentPage((prevPage) => {
      const newPage = prevPage < totalPages ? prevPage + 1 : prevPage;
      if(profile.length > 0){
        calculatePagination(newPage,profile);
      }
      return newPage;
    });
  };
  
  const handlePrevPage = () => {
    setCurrentPage((prevPage) => {
      const newPage = prevPage > 1 ? prevPage - 1 : prevPage;
      if(profile.length > 0){
        calculatePagination(newPage,profile);
      }
      // calculatePagination(newPage,insuranceData);
      return newPage;
    });
  };


  const getButtonClass = (page) =>
    `btn btn-link w-100   text-decoration-none ${
      filter === page ? "btn btn-primary text-light" : "text-dark"
    }`;

  useEffect(()=>{

    if(pageChanged && tableRef.current){
  tableRef.current.scrollIntoView({ behavior: "smooth"});
      }
      else{
        console.log("element not found");
      }
      return ()=>{
        setPageChanged(false);
      }
  },[pageChanged]);

  const getOmanVisaOrders = async () => {
       setLoading(true);
       setCurrentPage(1);
        var get_order_url = base_url+"/get_oman_visa_order_list";
        
        debugger
        fetch(get_order_url, {
          method: 'POST',
          headers: {
            'Authorization': `Bearer ${VendorKey}`,
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(Payload),
        })
          .then(response => response.json())
          .then(data => {
            debugger
          // const testData = Array(15).fill(data.result[0]);
          // data.result = testData;
          if(filter==="success"){
            setLoading(false);
            const filterSuccess = data.result.filter(item => item.payment_status.toLowerCase() === 'success' );
            setProfile(filterSuccess);
             // Set total pages based on data length
        const totalPagesCount = Math.ceil(filterSuccess.length / itemsPerPage);
        totalPagess(totalPagesCount);

        // Initial page calculation
        calculatePagination(1,filterSuccess);
          }
          else if(filter==="pending"){
             setLoading(false);
            const filterPending = data.result.filter(item => item.payment_status.toLowerCase() !== 'success' && item.is_deleted=="no");
            setProfile(filterPending);
             // Set total pages based on data length
        const totalPagesCount = Math.ceil(filterPending.length / itemsPerPage);
        totalPagess(totalPagesCount);

        // Initial page calculation
        calculatePagination(1,filterPending);
          }
          })
          .catch(error => {
            console.error('Error fetching countries:', error);
          });
        }
  
  useEffect(() => {

      // const location  = new URL(window.location.href);
      // const staffid = location.searchParams.get('staff_id');


      //   var vkData = { token: usrtok, user_type: "agent", staff_id: staffid };
      if(VendorKey){
           getOmanVisaOrders();
        }
    }, [ VendorKey,Payload,filter]);


  const handleRemove = async(e,application_id) => {
    e.preventDefault();
    debugger;
    setLoading(true);
     fetch(base_url+"/oman_visa_app_cancel",{
          method:"POST",
          headers:{
            "Authorization":"Bearer "+VendorKey,
            "Content-Type":"application/json"
          },
          body:JSON.stringify({application_id:application_id})
        }).then((response)=>response.json())
        .then((data)=>{
          if(data.message==="success"){
            //  setFilter("pending");
             getOmanVisaOrders();
          }
        }).catch(err=>console.error("while updating application status err : "+err))
        .finally(() => {
          setLoading(false);
        });
  }


    const getUserType = () => {
    if (userData.agency_name) return "agent";
    if (userData.type === "staff" && userData.staff_first_name) return "staff";
    if(userData.first_name && userData.last_name)  return "user";
    return "";
  };

   const openPaymentGateway = async (app_id) => {
    if (!app_id || !VendorKey) {
      console.error(" Missing appId or vendorKey");
      return;
    }

    setLoading(true);

    const pay_data = {
      application_id: app_id,
      user_type: getUserType(),
      is_live: "true",
      save_selection: "true",
      currency: "OMR",
      fee_omr: 45,
      description: "Oman Visa Payment",
      token: userData.access_token,
    };

    try {
      const res = await fetch(`${base_url}/create_oman_visa_payment`, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${VendorKey}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify(pay_data),
      });

      if (!res.ok) throw new Error(`HTTP error! status: ${res.status}`);

      const result = await res.json();
      if (result.message === "success") {
        const parsedata = JSON.parse(result.result.payment_details);
        const { secureHash, trxParams } = parsedata;

        if (!window.SmartBox || !window.SmartBox.Checkout) {
          throw new Error("SmartBox payment gateway not loaded");
        }

        window.SmartBox.Checkout.configure = {
          MID: trxParams.MerchantId,
          TID: trxParams.TerminalId,
          CurrencyId: trxParams.CurrencyId,
          AmountTrxn: trxParams.Amount,
          MerchantReference: trxParams.MerchantReference,
          LanguageId: "en",
          PaymentViewType: 1,
          TrxDateTime: trxParams.TrxDateTime,
          SessionToken: trxParams.SessionToken,
          SecureHash: secureHash,

          completeCallback: async (data) => {
            setLoading(true)
            try {
              const verifyRes = await axios.post(
                `${base_url}/oman_visa_payment_status`,
                data.data
              );
              if (verifyRes.data.valid) {
                window.location.href = verifyRes.data.data;
              }
            } catch (err) {
              console.error("Verification failed:", err);
            } 
          },

          errorCallback: (error) => {
            console.error("❌ Payment Error:", error);
            setLoading(false);
            window.location.href = `/oman-visa-form-status?application_id=${btoa(app_id)}&payment_status=failed`;
          },

          cancelCallback: (cancel) => {
            console.log("⚠️ Payment Cancelled:", cancel);
            setLoading(false);
          },
        };

        window.SmartBox.Checkout.showSmartBox();
      } else {
        throw new Error(result.message || "Payment creation failed");
      }
    } catch (err) {
      console.error("Error creating payment:", err);
      setLoading(false);
    }finally{
      setLoading(false);
    }
  };


  const handlePayment = (e,app_id) => {
      e.preventDefault();
       setTimeout(()=>{
                      openPaymentGateway(app_id);
                  },1000);
  
  };



  const handleDownload=(e,links)=>{
    e.preventDefault();
    
    const anchor = document.createElement("a");
    anchor.href=links;
    anchor.target="_blank";
    anchor.alt="visa order";
    anchor.download = links.split('/').pop();
    document.body.appendChild(anchor);
   anchor.click();
   document.body.removeChild(anchor);
  }



  return (
    <div>


      <div className="features_section my-1">
         <div className="container">

                <div className="row  d-flex justify-content-end">
           
                
                <div className="col-lg-4 col-md-6 pt-5 ">
                  <div className="w-100 orders-table">    
                <ul className={`list-unstyled mb-0 p-0 d-flex justify-content-end ${lnstr=="ar"?"mr-3":"ml-3"}`}>
                  <li  style={{ 
                    // flex: "1 1 0", /* grow, shrink, basis */
          textAlign: "center",
          border: "1px solid #ccc",
          // borderTopLeftRadius:"5px",
          // borderBottomLeftRadius:"5px",
         backgroundColor:filter==="success"?"#3fd2f2":"",
          //  borderRadius:"20px 0px 0px 20px"
          }}>
                    <button
                      className={getButtonClass("success")}
                      style={{ fontSize: "18px",textAlign:"center",  borderRadius:"20px 0px 0px 20px" }}
                      onClick={(e) => {e.preventDefault(); setFilter("success")}}
                    >
                      {t("Success")}
                    </button>
                  </li>
                  <li   style={{ 
                    // flex: "1 1 0", /* grow, shrink, basis */
          textAlign: "center",
          border: "1px solid #ccc",
          backgroundColor:filter==="pending"?"#3fd2f2":"",
          // borderRadius:"0px 20px 20px 0px"
         }}>
                    <button
                      className={getButtonClass("pending")}
                      style={{ fontSize: "18px" ,textAlign:"center",  borderRadius:"0px 20px 20px 0px"}}
                      onClick={(e) => {e.preventDefault();  setFilter("pending")}}
                    >
                      {t("Pending")}
                    </button>
                  </li>
                </ul>
                </div>
        
               
             
        </div>
        </div>
          <div className="row g-4 justify-content-center">

            <div className="col-12 wow fadeInUp" data-wow-delay="0.2s" style={{ overflowX: 'auto' }}>
              {/* { userData != null && userData != undefined && userData.agency_name != null && userData.agency_name != undefined ?

              <div className='row'>
                <div className='col-6'><b style={{ textTransform: 'uppercase', fontSize: 17 }}>{userData.agency_name != null && userData.agency_name != undefined ? userData.agency_name: <span>{userData.first_name} {userData.last_name}</span>}</b></div>
                
              </div> : <></>

               } */}

              {
                <div className="orders-table" ref={tableRef}>
         
                
                  <table  className='table table-bordered mt-3'>
                    <thead ><tr><th rowSpan={2} >#</th>
                     <th rowSpan={2}>{t('Date of Application')}</th>
                     <th rowSpan={2}>{t('Application')} {t('ID')}</th> 
                     <th rowSpan={2}>{t('Full Name')}</th> 
                     {/* {<th>{t('User')} {t('ID')}</th>}  */}

                      <th rowSpan={2} >{t('email')}</th>
                      <th rowSpan={2} >{t('Visa Type')}</th>
                      
                      
                     <th rowSpan={2}>{t("Status")}</th>
                     
                      {filter==="success" && <th rowSpan={2}>{t('Download')}</th>}

                       {  <th rowSpan={2}>{t('View')}</th>}

                      {filter!=="success" && <th rowSpan={2} colSpan={2} style={{textAlign:"center"}}>{t('Action')}</th>}

                      </tr>
                      
                      {/* <tr><th style={{ width: '15%' }}>{t('From')}</th>
                      <th style={{ width: '15%' }}>{t('To')}</th></tr> */}

                      </thead>
                    <tbody>

                      {(currentItems?.length === 0) ? <tr><td colSpan={8} className='text-center'>{t('No')} {t('Records')} {t('Found')}</td></tr> : ''}
                      {currentItems?.map((prof, index) => {
                        return (
                          <tr key={index}>
                            <td>{indexOfFirstItem+index + 1}</td>
                            <td>{format(new Date(prof.created_at), 'dd/MM/yyyy')}</td>
                            <td>{prof?.application_id}</td>
                            {/* <td>{t(traveller_details?.id)}</td> */}
                            <td>{prof?.full_name}</td>
                            <td>{prof?.email}</td>
                            <td>{prof?.visa_type}</td>
                            {/* {userData != null && userData != undefined && userData.agency_name != null && userData.agency_name != undefined ? <td></td>:  <td>{prof.fee} ({prof.currency})</td>} */}
                            {/* <td>{prof.earnings} ({prof.currency})</td> */}
                          
                           
                           <td>
                            {prof?.order_status}
                          </td>
                           
                             
                            {/* Download button */}
                            {filter==="success" &&  <td>
                              {prof.order_status==='completed' && prof.links?
                              <Button
                                variant="primary"
                                style={{ fontWeight: 'normal' }}
                                className="btn btn-primary rounded-pill text-white py-1 px-2"
                                onClick={(e)=>handleDownload(e,prof.links)}
                                disabled={prof.order_status!=='completed' && !prof.links}
                              >
                              {t('Download')}
                              </Button>
                              :
                             "Not Available"
                      }
                            </td>}

                            <td>
                              <Button
                                variant="primary"
                                style={{ fontWeight: 'normal' }}
                                className="btn btn-primary rounded-pill text-white py-1 px-2"
                                onClick={(e)=>handleStatus(e,prof?.application_id)}
                             
                              >
                              {t('View')}
                              </Button>
                            </td>

                                { filter !== "success" && 
                           <>
                           <td>
                            
                            <button
                              onClick={(e) => handlePayment(e,prof?.application_id)}
                               className="btn btn-primary rounded-pill text-white py-1 px-2"
                              // onClick={() => openIframe(`https://superjet.simplevisa.net/travellers/deeplinks/sign_in/FQ6RtrhUmQgeZwHClSPGopP7l8x8djBAWQIIdrO13FM`)}
                              style={{ background: "none", border: "none", cursor: "pointer" }}
                            >
                              {t("Pay")}
                            </button>
                       
                          </td>
                            <td>
                              <Button
                                variant="primary"
                                style={{ fontWeight: 'normal' }}
                                className="btn btn-primary rounded-pill text-white py-1 px-2"
                                onClick={(e) => handleRemove(e, prof?.application_id)}
                              >
                              {t('Cancel')}
                              </Button>
                            </td>
                            </>}
                          </tr>
                        );
                      })}
                    </tbody>
                  </table> 
                </div>
              }
              {totalPages === 0 ? <div></div> : <div className="pagination-controls-new">
                <button onClick={handlePrevPage} disabled={currentPage === 1}>
                  ‹
                </button>
                <span>

                </span>
                <span>
                  {t('Page')} {currentPage} {t('of')} {totalPages}
                </span>
                <span>

                </span>
                <button onClick={handleNextPage} disabled={currentPage === totalPages}>
                  ›
                </button>
              </div>}
              {/* {userData != null && userData != undefined && userData.agency_name != null && userData.agency_name != undefined && <h3 style={{textAlign:"right"}}>{t('Total')} {t('Earnings')} :  {totalEarnings}</h3>} */}
            </div>
          </div>
        </div>
      </div>
      


      {/* <Footer /> */}
        {loading && (
        <div className="overlay">
          <div className="spinner"></div>
        </div>
      )}



      {showIframe && (
        <div className='modal'>
          <div className = 'modal-content'style={{height: "600px" }}>
            <h2>{t("Download")}</h2>
            <button type="button" className="close" onClick={closeIframe}>
          &times; 
        </button>
        <div>

        <iframe
            src={iframeUrl1}
            style={{ width: "100%", height: "500px", border: "none" }}
            title="API Content"
          ></iframe>

        </div>
          </div>
        </div>
      )}


      {show && (
        <div className='modal'>
          <div className='modal-content' style={{height: "650px" , width:'700px'}}>
          <h2><span>{t('Order')} {t('Status')}</span></h2>
          <button type="button" className="close" onClick={handleClose}>
          &times;
          </button>
          <div style={{height:'20px'}}></div>
          <div className='d-flex justify-content-center'>

            <table style={{ width:'250'}}>
            <tr><td style={{ fontWeight: 'bold', textAlign:'left' }}>{t('Application ID')}</td><td style={{ fontWeight: 'bold', textAlign:'left'}}>:</td><td style={{textAlign:'left'}}><b>{odata?.application_id}</b></td></tr>


            <tr><td style={{ fontWeight: 'bold', textAlign:'left' }}>{t('Order Status')}</td><td style={{ fontWeight: 'bold', textAlign:'left'}}>:</td><td style={{ textTransform: 'capitalize', textAlign:'left' }}><b>{odata?.order_status != null && odata?.order_status != undefined ? odata?.order_status : ""}</b></td></tr>

              <tr><td style={{ fontWeight: 'bold', textAlign:'left' }}>{t('Status')}</td><td style={{ fontWeight: 'bold', textAlign:'left'}}>:</td><td style={{ textTransform: 'capitalize', textAlign:'left' }}><b>{odata?.application_status != null && odata?.application_status != undefined ? odata?.application_status : ""}</b></td></tr>


            <tr><td style={{ fontWeight: 'bold', textAlign:'left' }}>{t('Full Name')}</td><td style={{ fontWeight: 'bold', textAlign:'left'}}>:</td><td style={{ textTransform: 'capitalize', textAlign:'left' }}><b>{odata?.full_name != null && odata?.full_name != undefined ? odata?.full_name : ''}</b></td></tr>

      
            {/* <tr><td style={{ fontWeight: 'bold' }}>{t('DOB')}</td><td style={{ paddingLeft: 10, paddingRight: 10 }}>:</td><td style={{ textTransform: 'capitalize' }}><b>{odata?.dob != null && odata?.dob != undefined ? odata?.dob.split('T')[0] : ''}</b></td></tr> */}
            <tr><td style={{ fontWeight: 'bold', textAlign:'left' }}>{t('Email')}</td><td style={{ fontWeight: 'bold', textAlign:'left'}}>:</td><td style={{textAlign:'left'}}><b>{odata?.email != null && odata?.email != undefined ? odata.email : ''}</b></td></tr>
            <tr><td style={{ fontWeight: 'bold', textAlign:'left' }}>{t('Gender')}</td><td style={{ fontWeight: 'bold', textAlign:'left'}}>:</td><td style={{textAlign:'left'}}><b>{odata?.gender != null && odata?.gender != undefined ? odata.gender : ''}</b></td></tr>
            <tr><td style={{ fontWeight: 'bold', textAlign:'left' }}>{t('Date of Birth')}</td><td style={{ fontWeight: 'bold', textAlign:'left'}}>:</td><td style={{textAlign:'left'}}><b>{odata?.dob != null && odata?.dob != undefined ? odata.dob : ''}</b></td></tr>
            <tr><td style={{ fontWeight: 'bold', textAlign:'left' }}>{t('Nationality')}</td><td style={{ fontWeight: 'bold', textAlign:'left'}}>:</td><td style={{textAlign:'left'}}><b>{odata?.nationality != null && odata?.nationality != undefined ? odata.nationality : ''}</b></td></tr>
            <tr><td style={{ fontWeight: 'bold', textAlign:'left' }}>{t('Passport No')}</td><td style={{ fontWeight: 'bold', textAlign:'left'}}>:</td><td style={{textAlign:'left'}}><b>{odata?.passport_no != null && odata?.passport_no != undefined ? odata.passport_no : ''}</b></td></tr>
           
            <tr><td style={{ fontWeight: 'bold', textAlign:'left' }}>{t('Visa Type')}</td><td style={{ fontWeight: 'bold', textAlign:'left'}}>:</td><td style={{ textTransform: 'capitalize', textAlign:'left' }}><b>{odata?.visa_type != null && odata?.visa_type != undefined ? odata?.visa_type : ''}</b></td></tr>

            <tr><td style={{ fontWeight: 'bold', textAlign:'left' }}>{t('Passport Validity')}</td><td style={{ fontWeight: 'bold', textAlign:'left'}}>:</td><td style={{ textTransform: 'capitalize', textAlign:'left' }}><b>{odata?.passport_issue_date != null && odata?.passport_issue_date != undefined ? odata?.passport_issue_date : ''}&nbsp;{'to'} &nbsp;{odata?.passport_expiry_date != null && odata?.passport_expiry_date != undefined ? odata?.passport_expiry_date : ''}</b></td></tr>
            
            <tr><td style={{ fontWeight: 'bold', textAlign:'left' }}>{t('Place / Country of Issue')}</td><td style={{ fontWeight: 'bold', textAlign:'left'}}>:</td><td style={{ textTransform: 'capitalize', textAlign:'left' }}><b>{odata?.place_of_issue != null && odata?.place_of_issue != undefined ? odata?.place_of_issue : ''}, {odata?.country_of_issue != null && odata?.country_of_issue != undefined ? odata?.country_of_issue : ''}</b></td></tr>

            <tr><td style={{ fontWeight: 'bold', textAlign:'left' }}>{t('Duration of Stay')}</td><td style={{ fontWeight: 'bold', textAlign:'left'}}>:</td><td style={{ textTransform: 'capitalize', textAlign:'left' }}><b>{odata?.duration_of_stay != null && odata?.duration_of_stay != undefined ? odata?.duration_of_stay : ''}</b></td></tr>
            <tr><td style={{ fontWeight: 'bold', textAlign:'left' }}>{t('Country of Origin Mobile')}</td><td style={{ fontWeight: 'bold', textAlign:'left'}}>:</td><td style={{ textTransform: 'capitalize', textAlign:'left' }}><b>{odata?.origin_mobile != null && odata?.origin_mobile != undefined ? odata?.origin_mobile : ''}</b></td></tr>
            <tr><td style={{ fontWeight: 'bold', textAlign:'left' }}>{t('Mobile No in Oman')}</td><td style={{ fontWeight: 'bold', textAlign:'left'}}>:</td><td style={{ textTransform: 'capitalize', textAlign:'left' }}><b>{odata?.oman_mobile != null && odata?.oman_mobile != undefined ? odata?.oman_mobile : ''}</b></td></tr>

            <tr><td style={{ fontWeight: 'bold', textAlign:'left' }}>{t('Fee')}</td><td style={{ fontWeight: 'bold', textAlign:'left'}}>:</td><td style={{ textTransform: 'capitalize', textAlign:'left' }}><b>{odata?.fee != null && odata?.fee != undefined ? odata?.fee : ''}</b>{" "}<b>{odata?.currency != null && odata?.currency != undefined ? odata?.currency : ''}</b></td></tr>

          

            <tr><td style={{ fontWeight: 'bold', textAlign:'left'  }}>{t('Payment Status')}</td><td style={{paddingRight: 10  , fontWeight: 'bold', textAlign:'left'}}>:</td><td style={{ textTransform: 'capitalize', textAlign:'left' }}><b>{odata?.payment_status !=null && odata?.payment_status != undefined ?odata?.payment_status:''}</b></td></tr>

            <tr><td style={{ fontWeight: 'bold', textAlign:'left'  }}>{t('Date of Application')}</td><td style={{paddingRight: 10  , fontWeight: 'bold', textAlign:'left'}}>:</td><td style={{ textTransform: 'capitalize', textAlign:'left' }}><b>{odata?.created_at != null && odata?.created_at != undefined ? odata?.created_at.split('T')[0] : ''}</b></td></tr>
          </table>
        
          </div>
          <div>
            <button type="button"   class="btn btn-sm btn-close d-none d-md-inline-block" aria-label="Close" onClick={handleClose}>Close</button>
            </div>

          </div>
        </div>
      )}





     

     </div>
  );
};

export default MyOmanVisaTable;